import { LIVESHOWS } from "../types";

export const liveshowsReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case LIVESHOWS: {
			const { data } = payload;
			state = [];
			return data;
		}
		default: {
			return state;
		}
	}
};
